"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Progress = void 0;
var react_1 = __importDefault(require("react"));
var Progress = function (_a) {
    var bars = _a.bars, filled = _a.filled, _b = _a.customClasses, customClasses = _b === void 0 ? "" : _b;
    var Bars = function () {
        var elements = [];
        for (var i = 0; i < bars; i++) {
            var active = (i < filled);
            elements.push(react_1.default.createElement("div", { className: "axxes-progress__" + (active ? "filled" : "empty"), key: i }));
        }
        return react_1.default.createElement(react_1.default.Fragment, null, elements);
    };
    return (react_1.default.createElement("div", { className: "axxes-progress " + customClasses },
        react_1.default.createElement(Bars, null)));
};
exports.Progress = Progress;
